import { KYMW0D00Model } from './../kymw0d00.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';

/**
 * 処理ログ 処理結果ログ削除クラス
 *
 * @export GetLogProcessResultService
 * @class GetLogProcessResultService
 * @extends PlessJsonResponderSub
 */
@Injectable()
export class GetLogProcessResultService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW0D00Model;
  private vo: any;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetLogProcessResultService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        DispId: this.vo.dispId
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetLogProcessResultService
   */
  execute(model: KYMW0D00Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getLogProcessResult', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetLogProcessResultService
   */
  success(data: any): void {
    this.model.updateServerResponse(data);
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
